/* global $ */
import merge from 'lodash/merge'
import { isDatatableReady, toggleDatatableReorder } from '../datatables/helpers.js'

import 'datatables.net'
import 'datatables.net-bs4'

import 'datatables.net-responsive'
import 'datatables.net-responsive-bs4'

merge(
    $.fn.dataTable.defaults,
    {
        ajax: {
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
        },
        language: {
            paginate: {
                first: '<i class="las la-angle-double-left"></i>',
                last: '<i class="las la-angle-double-right"></i>',
                next: '<i class="las la-angle-right"></i>',
                previous: '<i class="las la-angle-left"></i>'
            }
        }
    }
)

$(document)
    .off('change', '.dataTable_filter')
    .on('input', '.dataTable_filter', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const wrapper = $(this).closest('.dataTables_wrapper_extended')
        const dataTables = wrapper.find('table')

        // Loop through all the tables that are on the page.
        $.each(dataTables, function (key, datatable) {
            // Check if table exists and the table is a DataTable.
            if (window[$(this).attr('id')] && $.fn.DataTable.isDataTable($(this))) {
                toggleDatatableReorder($(this).attr('id'))

                if (isDatatableReady($(datatable))) {
                    window[$(this).attr('id')].ajax?.reload()
                }
            }
        })
    })

$.fn.dataTable.ext.errMode = function (settings) {
    if (settings?.jqXHR && !(settings.jqXHR?.status === 401 || settings.jqXHR?.status === 419)) {
        // Handling for all exceptions (except expired session and token mismatch)
        return 'alert'
    }

    return 'none'
}

export {}
